import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { environment } from 'env/cashier';

import { convertToLocale } from '@cashier/cashier-common';
import { CashierClient } from '@cashier/cashier-data-access';
import {
  createCombinedFeatureStore,
  generateAuthorizationToken,
} from '@cashier/cashier-shared';
import { PaymentProcessingFeature } from '@cashier/feature/payment-processing';
import { PaymentResultFeature } from '@cashier/feature/payment-result';

import { MainAppFeature } from 'app/elements/features';
import { useBootstrapConfiguration } from 'app/elements/hooks';
import { getAppRouter } from './elements/routes';

const params = new URLSearchParams(window.location.search);

const merchantId = params.get('merchantId');
const userId = params.get('userId');
const sessionId = params.get('sessionId');
const language = params.get('language');

const cashierClient = new CashierClient(
  environment.paymentGatewayApiUrl,
  convertToLocale(language),
  generateAuthorizationToken({ merchantId, userId, sessionId }),
);

const store = createCombinedFeatureStore(
  [
    PaymentProcessingFeature.store,
    PaymentResultFeature.store,
    MainAppFeature.store,
  ],
  { Api: cashierClient },
);

export const App = () => {
  useBootstrapConfiguration(environment);

  return (
    <Provider store={store}>
      <RouterProvider router={getAppRouter(store)} />
    </Provider>
  );
};
